import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-center mt-6 w-full" }
const _hoisted_2 = { class: "flex items-center justify-center p-6 overflow-visible w-[96%] overflow-x-hidden rounded-lg bg-white border border-gray-200 shadow-md" }
const _hoisted_3 = { class: "flex flex-col items-center w-full" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "form",
  class: "flex flex-col gap-4 xs:w-full md:w-[643px] mt-6 xs:pb-11 md:pb-0"
}
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = {
  key: 0,
  class: "text-red-500 font-inter text-sm font-normal mt-2"
}
const _hoisted_8 = { class: "text-gray-700 text-sm font-inter font-medium mb-1 flex items-center" }
const _hoisted_9 = { class: "w-full flex items-center md:flex-row md:justify-between xs:flex-col xs:justify-center xs:gap-2 md:gap-0" }
const _hoisted_10 = { class: "bg-gray-100 border border-gray-300 rounded-xl min-h-[100px] min-w-[100px] h-fit w-fit flex p-2 items-center justify-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "w-3/4" }
const _hoisted_13 = {
  key: 0,
  class: "text-red-500 font-inter text-sm font-normal"
}
const _hoisted_14 = { class: "flex xs:flex-col md:flex-row gap-6" }
const _hoisted_15 = { class: "xs:w-full md:w-1/2" }
const _hoisted_16 = { class: "xs:w-full md:w-1/2" }
const _hoisted_17 = {
  id: "comment-and-tooltip-container",
  class: "relative"
}
const _hoisted_18 = { class: "absolute left-36" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "border rounded-lg w-full p-4 flex justify-between gap-2" }
const _hoisted_21 = { class: "flex flex-col gap-2" }
const _hoisted_22 = { class: "text-gray-800 font-inter font-semibold text-base" }
const _hoisted_23 = { class: "text-gray-800 font-inter font-normal text-sm" }
const _hoisted_24 = { class: "flex justify-end w-full" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "text-gray-800 font-inter font-normal text-base text-left mt-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "text-gray-800 font-inter font-semibold text-base" }
const _hoisted_29 = { class: "text-gray-800 font-inter font-normal text-sm" }
const _hoisted_30 = { class: "flex justify-end p-3" }

import Joi, { ValidationError } from "joi";
import { useMutation } from "@vue/apollo-composable";
import { UseMutationReturn } from "@vue/apollo-composable/dist/useMutation";
import StoreBuildMutation from "@/Graphql/Welcome/StoreBuildRequest.mutation.graphql";
import { reactive, computed, onMounted, ref } from "vue";
import SelectMenu from "@/Partials/SelectMenu.vue";
import Alert from "@/Partials/Alert.vue";
import Modal from "@/Partials/Modal.vue";
import Tooltip from "../Tooltip.vue";
import { COLORS } from "@/Constants/LogoColors";
import { ACTIVITIES } from "@/Constants/Activities";
import { ALERT_TYPE } from "@/Constants/Alert";
import image from "@/assets/images/StoreLeadFormSM1Update_Graphic.png";
import { IOption } from "@/interfaces/SupportInterfaces";
import { useMainStore } from "@/store/MainStore";
import { useAuthStore } from "@/store/AuthStore";
import { ICampaign, IStoreBuildResult } from "@/interfaces/StoreInterfaces";
import Loader from "../Spinner.vue";
import router from "@/Router";
import { getFullName } from "@/utilities";
import { ITooltip } from "@/interfaces/CommonInterfaces";
import { MutationStoreBuildRequestArgs } from "@/types/graphql";
// Interfaces
interface IStoreDetails {
  storeName: string;
  storeActivity: string;
  primaryColor: string;
  secondaryColor: string;
  comment?: string;
  campaignId: number | null;
  storeLogo: string;
  requester: {
    name: string;
    email: string;
  };
}
interface IErrorMessage {
  storeName: string;
  storeActivity: string;
  primaryColor: string;
  secondaryColor: string;
  comment: string;
  storeLogo: string;
}
// Constants
const INITIAL_CAMPAIGN_ID = null;
interface IState {
  logoColors: IOption[];
  errorMessages: IErrorMessage;
  hasValidationError: string[];
  storeDetails: IStoreDetails;
  isFocussed: string;
  hasActiveRaiseCampaigns: boolean;
  showCampaignsModal: boolean;
  selectedCampaign: ICampaign | null;
  activityTooltip: ITooltip;
  primaryColorTooltip: ITooltip;
  secondaryColorTooltip: ITooltip;
}
// GraphQL

export default /*@__PURE__*/_defineComponent({
  __name: 'SelfSignUpForm',
  setup(__props) {

// Imports
const INITIAL_ERROR_MESSAGES = {
  storeName: "",
  storeLogo: "",
  storeActivity: "",
  primaryColor: "",
  secondaryColor: "",
  comment: "",
};
const { mutate: sendStoreBuildRequest, loading }: UseMutationReturn<IStoreBuildResult, MutationStoreBuildRequestArgs> = useMutation(StoreBuildMutation);
// Stores
const mainStore = useMainStore();
const authStore = useAuthStore();
// State
const alertRef = ref<InstanceType<typeof Alert>>();
let showAllErrors = ref(false);
let state: IState = reactive({
  logoColors: COLORS,
  storeDetails: {
    storeName: "",
    storeActivity: "",
    primaryColor: "",
    secondaryColor: "",
    comment: "",
    campaignId: INITIAL_CAMPAIGN_ID,
    storeLogo: "",
    requester: {
      name: getFullName(authStore.getCurrentUser.firstName, authStore.getCurrentUser.lastName),
      email: authStore.getCurrentUser.email,
    },
  },
  errorMessages: { ...INITIAL_ERROR_MESSAGES },
  hasActiveRaiseCampaigns: false,
  showCampaignsModal: false,
  isFocussed: "",
  hasValidationError: [],
  selectedCampaign: null,
  activityTooltip: {
    heading: "Activity",
    text: "Please select the activity type of your program",
  },
  primaryColorTooltip: {
    heading: "Primary Color",
    text: "Please select the primary color of your program. This will help us with your logo and will be used for the theme color of your store.",
  },
  secondaryColorTooltip: {
    heading: "Secondary Color",
    text: "Please select the secondary color of your program. This will help us with your logo.",
  },
});
// Computed
const getActiveAndUpcomingCampaigns = computed(() => {
  return mainStore.campaigns.filter(({ status }) => status.toLowerCase() === "active" || status.toLowerCase() === "approved");
});
const isDisabled = computed(() => {
  return JSON.stringify(INITIAL_ERROR_MESSAGES) !== JSON.stringify(state.errorMessages);
});

// Methods
const setFieldValues = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const trimmedValue = target.value.trim();
  const numericValue = Number(trimmedValue);
  if (trimmedValue.length) {
    if (!isNaN(numericValue)) {
      state.storeDetails[target.name] = String(numericValue);
    } else {
      state.storeDetails[target.name] = trimmedValue;
    }
  } else {
    state.storeDetails[target.name] = trimmedValue;
  }
  state.isFocussed = target.name.toString().trim();
  state.hasValidationError.push(target.name.toString());
  validateInputs();
};
const setActivity = (updatedActivityArray: IOption[]) => {
  const selectedOption = updatedActivityArray.find((option) => option.selected === true);
  state.storeDetails.storeActivity = selectedOption?.value ?? "";
  validateInputs();
};
const setPrimaryColor = (updatedColorsArray: IOption[]) => {
  const selectedOption = updatedColorsArray.find((option) => option.selected === true);
  state.storeDetails.primaryColor = selectedOption?.value ?? "";
  validateInputs();
};
const setSecondaryColor = (updatedColorsArray: IOption[]) => {
  const selectedOption = updatedColorsArray.find((option) => option.selected === true);
  state.storeDetails.secondaryColor = selectedOption?.value ?? "";
  validateInputs();
};
const updateCheckBoxValue = (checkbox: { checked: boolean; value: string }) => {
  if (checkbox.checked) {
    state.showCampaignsModal = true;
  } else {
    resetCampaign();
    state.showCampaignsModal = false;
  }
  state.hasActiveRaiseCampaigns = checkbox.checked;
};
const selectCampaign = (campaign: ICampaign) => {
  if (state.selectedCampaign?.id === campaign.id) {
    state.selectedCampaign = null;
  } else {
    state.selectedCampaign = campaign;
  }
};
const resetCampaign = () => {
  state.selectedCampaign = null; // to display all data under checkbox
  state.storeDetails.campaignId = INITIAL_CAMPAIGN_ID; // for payload
  state.hasActiveRaiseCampaigns = true; // checkbox value
};
const saveSelectedCampaign = () => {
  state.storeDetails.campaignId = state.selectedCampaign?.id ?? INITIAL_CAMPAIGN_ID;
  state.storeDetails.campaignId === INITIAL_CAMPAIGN_ID ? (state.hasActiveRaiseCampaigns = false) : "";
  state.showCampaignsModal = false;
};
const closeCampaignModal = () => {
  if (!state.selectedCampaign) {
    resetCampaign();
    state.hasActiveRaiseCampaigns = false;
  }
  state.showCampaignsModal = false;
};
// Validation Schema
const nameRegex = /^[a-zA-Z0-9-\s]+$/;
const schema = Joi.object({
  storeName: Joi.string().required().pattern(nameRegex).label("Store Name").messages({
    "string.empty": "Store name is required.",
    "string.pattern.base": "Store name should only contain letters, numbers, spaces, and hyphens.",
  }),
  storeLogo: Joi.string().required().messages({
    "string.empty": "Please select a store logo.",
  }),
  storeActivity: Joi.string().required().messages({
    "string.empty": "Please select an activity.",
  }),
  primaryColor: Joi.string().required().messages({
    "string.empty": "Please select a primary color.",
  }),
  secondaryColor: Joi.string().required().messages({
    "string.empty": "Please select a secondary color.",
  }),
  comment: Joi.string().allow("").optional().max(500),
});
const validateInputs = async (): Promise<ValidationError | undefined> => {
  let validationSchema = {
    storeName: state.storeDetails.storeName,
    storeLogo: state.storeDetails.storeLogo,
    storeActivity: state.storeDetails.storeActivity,
    primaryColor: state.storeDetails.primaryColor,
    secondaryColor: state.storeDetails.secondaryColor,
    comment: state.storeDetails.comment,
  };
  const validation = schema.validate(validationSchema, {
    abortEarly: false,
  });
  state.errorMessages = { ...INITIAL_ERROR_MESSAGES };
  validation.error?.details.forEach(({ path, message }) => {
    state.errorMessages[path[0]] = message;
  });
  return validation.error;
};
const handleSubmit = (callback: () => void) => {
  validateInputs();
  !isDisabled.value ? callback() : (showAllErrors.value = true);
};
const handleFileUploaded = async (uploadedFiles: any) => {
  const base64Data = await convertFileToBase64(uploadedFiles[0]);
  state.storeDetails.storeLogo = base64Data;
  validateInputs();
};
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Data = reader.result as string;
      resolve(base64Data);
    };
    reader.onerror = (error) => reject(error);
  });
};

const submit = () => {
  try {
    sendStoreBuildRequest({ input: state.storeDetails }).then((data) => {
      if (data?.data?.storeBuildRequest.referenceTicket) {
        router.push({ name: "PostSubmissionBanner" });
      } else {
        alertRef.value?.displayAlert(ALERT_TYPE.ERROR, {
          title: `Error: ${data?.data?.storeBuildRequest.exceptionCode}`,
          text: data?.data?.storeBuildRequest?.message ?? "Something went wrong.",
        });
      }
    });
  } catch (error) {
    alertRef.value?.displayAlert(ALERT_TYPE.ERROR, {
      title: "Error",
      text: "Store build Request failed",
    });
  }
};
const supportedFormats = ref<string[]>([]);
const setSupportedFormats = () => {
  setTimeout(() => {
    supportedFormats.value = ["png", "jpg", "gif"];
  }, 500);
};
onMounted(() => setSupportedFormats());

return (_ctx: any,_cache: any) => {
  const _component_snap_input = _resolveComponent("snap-input")!
  const _component_snap_file_uploader = _resolveComponent("snap-file-uploader")!
  const _component_snap_checkbox_button = _resolveComponent("snap-checkbox-button")!
  const _component_snap_badge = _resolveComponent("snap-badge")!
  const _component_snap_icon = _resolveComponent("snap-icon")!
  const _component_snap_button = _resolveComponent("snap-button")!
  const _component_snap_card_title = _resolveComponent("snap-card-title")!
  const _component_snap_card_header = _resolveComponent("snap-card-header")!
  const _component_snap_card_content = _resolveComponent("snap-card-content")!
  const _component_snap_card_footer = _resolveComponent("snap-card-footer")!
  const _component_snap_card = _resolveComponent("snap-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _unref(image),
            alt: "image",
            class: "block w-[300px]"
          }, null, 8, _hoisted_4),
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-gray-900 font-semibold text-4xl mt-4" }, "Welcome to Snap! Store", -1)),
          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-gray-900 font-normal text-base font-inter mt-2 text-left xs:w-full md:w-[643px]" }, " Store is a free feature with all tiers of Snap! Mobile One. Generate revenue for your program year-round with customized fan gear. You don't currently have a Store with us. Please enter the information below and our team will get one created for you! ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_snap_input, {
                _type: "text",
                label: "Store Name",
                name: "storeName",
                "help-text": "Please enter your school name, sport/club type, and/or mascot name. (Example: Snap High Blues Baseball)",
                error: _unref(state).errorMessages.storeName.length ? true : false,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (setFieldValues($event)))
              }, null, 8, ["error"]),
              (_unref(state).hasValidationError.includes('storeName') || _unref(showAllErrors))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(state).errorMessages.storeName), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createVNode(SelectMenu, {
                id: "activity-select-menu",
                options: _unref(ACTIVITIES),
                "onUpdate:options": _cache[1] || (_cache[1] = ($event: any) => (_isRef(ACTIVITIES) ? (ACTIVITIES).value = $event : null)),
                label: "Activity",
                placeholder: "Select Activity",
                "help-text": "Please select the activity type of your program",
                tooltip: _unref(state).activityTooltip,
                "tooltip-position": "left-[48px]",
                "error-message": _unref(state).hasValidationError.includes('storeActivity') || _unref(showAllErrors) ? _unref(state).errorMessages.storeActivity : '',
                onOnSelect: setActivity
              }, null, 8, ["options", "tooltip", "error-message"])
            ]),
            _createElementVNode("p", _hoisted_8, [
              _cache[11] || (_cache[11] = _createTextVNode(" Logo ")),
              _createVNode(Tooltip, {
                heading: "Logo",
                text: "Please input your logo to be used on Products for your Store"
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_unref(state).storeDetails.storeLogo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      height: 100,
                      width: 100,
                      src: _unref(state).storeDetails.storeLogo,
                      alt: "logo",
                      class: "rounded-xl"
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_snap_file_uploader, {
                  counter: true,
                  "max-files-count": "1",
                  "button-only-mobile": "false",
                  "max-file-size": 10,
                  supportedFormats: supportedFormats.value,
                  onSnapFileUploaderUploaded: _cache[2] || (_cache[2] = ({ detail }) => handleFileUploaded(detail))
                }, null, 8, ["supportedFormats"]),
                (_unref(state).hasValidationError.includes('storeLogo') || _unref(showAllErrors))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(state).errorMessages.storeLogo), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(SelectMenu, {
                  id: "primary-color-select-menu",
                  options: _unref(state).logoColors,
                  "onUpdate:options": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).logoColors) = $event)),
                  label: "Primary Color",
                  placeholder: "Select Primary Color",
                  tooltip: _unref(state).primaryColorTooltip,
                  "tooltip-position": "left-[88px]",
                  "error-message": _unref(state).hasValidationError.includes('primaryColor') || _unref(showAllErrors) ? _unref(state).errorMessages.primaryColor : '',
                  onOnSelect: setPrimaryColor
                }, null, 8, ["options", "tooltip", "error-message"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(SelectMenu, {
                  id: "secondary-color-select-menu",
                  options: _unref(state).logoColors,
                  "onUpdate:options": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).logoColors) = $event)),
                  label: "Secondary Color",
                  placeholder: "Select Secondary Color",
                  tooltip: _unref(state).secondaryColorTooltip,
                  "tooltip-position": "left-[108px]",
                  "error-message": _unref(state).hasValidationError.includes('secondaryColor') || _unref(showAllErrors) ? _unref(state).errorMessages.secondaryColor : '',
                  onOnSelect: setSecondaryColor
                }, null, 8, ["options", "tooltip", "error-message"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(Tooltip, {
                  heading: "Additional Comments",
                  text: "Please add any additional comments about your logo. If you would like any modifications done to the design, please list them. We can support minor modifications to logo color, text, or outlines."
                })
              ]),
              _createVNode(_component_snap_input, {
                _type: "text",
                "corner-hint": "Optional",
                label: "Additional Comments",
                placeholder: "Please write a message",
                name: "comment",
                textarea: "",
                maxlength: 500,
                onInput: _cache[5] || (_cache[5] = ($event: any) => (setFieldValues($event)))
              })
            ]),
            _createVNode(_component_snap_checkbox_button, {
              id: "active-campaign-checkbox",
              "input-name": "campaign-checkbox",
              label: "I have a Snap! Raise campaign.",
              checked: _unref(state).hasActiveRaiseCampaigns,
              disabled: "false",
              locked: "false",
              value: "has-active-campaign",
              "checkbox-side": "left",
              "description-inline": "false",
              onSnapCheckboxUpdated: _cache[6] || (_cache[6] = ({ detail }) => updateCheckBoxValue(detail))
            }, null, 8, ["checked"]),
            (_unref(state).hasActiveRaiseCampaigns && _unref(state).storeDetails.campaignId && _unref(state).selectedCampaign)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-gray-800 font-inter text-sm font-medium mb-2" }, "Selected Campaign", -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_snap_badge, {
                        size: "lg",
                        color: _unref(state).selectedCampaign?.status.toLowerCase() === 'active' ? 'green' : 'gray',
                        dot: "false",
                        close: "false",
                        class: "capitalize"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(state).selectedCampaign?.status ?? "-"), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(state).selectedCampaign?.name ?? "-"), 1),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(state).selectedCampaign?.fullAddress ?? "-"), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex items-center text-blue-600 font-bold font-inter text-sm cursor-pointer",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(state).showCampaignsModal = true))
                    }, [
                      _createVNode(_component_snap_icon, {
                        color: "#3B82F6",
                        size: "xs",
                        state: "default",
                        icon: "pencil-alt-solid",
                        class: "mr-1"
                      }),
                      _cache[12] || (_cache[12] = _createTextVNode(" Edit "))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_snap_button, {
                id: "lead-form-submit-btn",
                variant: "primary",
                "full-width": true,
                size: "lg",
                disabled: isDisabled.value,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (handleSubmit(() => submit())))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    (_unref(loading))
                      ? (_openBlock(), _createBlock(Loader, { key: 0 }))
                      : _createCommentVNode("", true),
                    _cache[14] || (_cache[14] = _createTextVNode(" Submit "))
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Alert, {
      ref_key: "alertRef",
      ref: alertRef
    }, null, 512),
    (_unref(state).showCampaignsModal)
      ? (_openBlock(), _createBlock(Modal, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_snap_card, { class: "flex flex-col items-start xxs:w-full xs:w-full xs:h-screen xxs:h-screen sm:w-[490px] sm:h-fit sm:max-h-[570px]" }, {
              default: _withCtx(() => [
                _createVNode(_component_snap_card_header, { class: "flex justify-between" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_snap_card_title, { class: "text-gray-800" }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("Select a Campaign")
                      ])),
                      _: 1,
                      __: [17]
                    }),
                    _createVNode(_component_snap_icon, {
                      class: "cursor-pointer",
                      color: "#64748B",
                      icon: "x-line",
                      size: "xs",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (closeCampaignModal()))
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_26, _toDisplayString(getActiveAndUpcomingCampaigns.value.length
            ? "We found these campaigns associated with your account:"
            : "We are sorry we cannot find an associated Snap! Raise campaign with your account. Don’t worry, we can still process your Snap! Store request!"), 1),
                _createVNode(_component_snap_card_content, { class: "flex flex-col w-full items-start xxs:max-h-[90%] xs:max-h-[90%] overflow-y-auto gap-4" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getActiveAndUpcomingCampaigns.value, (campaign) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: campaign.id,
                        class: _normalizeClass(["border rounded-lg w-full p-4 flex flex-col gap-2 cursor-pointer", campaign.id === _unref(state).selectedCampaign?.id ? 'bg-blue-100 border-blue-600' : 'bg-white']),
                        onClick: ($event: any) => (selectCampaign(campaign))
                      }, [
                        _createVNode(_component_snap_badge, {
                          size: "lg",
                          color: campaign.status.toLowerCase() === 'active' ? 'green' : 'gray',
                          dot: "false",
                          close: "false",
                          class: "capitalize"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(campaign.status ?? "-"), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]),
                        _createElementVNode("p", _hoisted_28, _toDisplayString(campaign.name ?? "-"), 1),
                        _createElementVNode("p", _hoisted_29, _toDisplayString(campaign.fullAddress ?? "-"), 1)
                      ], 10, _hoisted_27))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_snap_card_footer, { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_snap_button, {
                        size: "xs",
                        variant: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "px-3",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (saveSelectedCampaign()))
                          }, _toDisplayString(getActiveAndUpcomingCampaigns.value.length ? "Save" : "Continue"), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})